/**
 * 回傳 Solutions Page 相關資料
 */

export function useSolutionsData() {
  const route = useRoute();
  const { blobDomain } = useWebsite();
  const { isTablet, isDesktop } = useScreen();

  /**
   * 提供完整的圖片網址
   * @param url - 圖片相對路徑
   * @returns 完整的圖片網址
   */

  const { solution, generic } = route.params;

  const provideImgUrl = (url: string): string => {
    const solutionId = generic ? `${solution}_${generic}` : solution;
    return `${blobDomain.value}/wise-paas-marketplace/solutions/${solutionId}/${url}`;
  };

  /**
   * 根據裝置類型回傳對應的響應式圖片網址
   * @param basename - 圖片基礎檔名（不含副檔名）
   * @returns 完整的圖片網址
   */

  const provideResponsiveImgUrl = (basename: string): string => {
    if (isDesktop.value) {
      return provideImgUrl(`${basename}.webp`);
    }
    if (isTablet.value) {
      return provideImgUrl(`${basename}_m.webp`);
    }
    return provideImgUrl(`${basename}_s.webp`);
  };

  return {
    provideImgUrl,
    provideResponsiveImgUrl,
  };
}
